<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>{{ __('user.role') }}</th>
            <th class="text-right">{{ __('general.actions') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="role in roles">
            <td class="pt-4">
                <span class="label label-xl label-inline text-capitalize" :style="labelStyle(role.color)">
                    <i class="fas fa-user-lock mr-2"></i>
                    {{ getStoreRole(role.name) }}
                </span>
            </td>
            <td class="text-right">
                <div v-if="role.custom" class="btn-group">
                    <a :href="$route('store.edit.role-permissions', {storeUuid: storeUuid, role: role.id})"
                       class="btn btn-sm btn-light-info px-4">
                        <i class="fas fa-pencil-alt"></i>
                        {{ __('actions.permissions.edit') }}
                    </a>
                    <a href="#" class="btn btn-sm btn-light-danger px-4">
                        <i class="fas fa-trash"></i>
                        {{ __('actions.role.remove') }}
                    </a>
                </div>
                <div v-else class="btn-group">
                    <a :href="$route('store.edit.role-permissions', {storeUuid: storeUuid, role: role.id})"
                       class="btn btn-sm btn-light-info px-4"><i class="fas fa-eye"></i>
                        {{ __('actions.permissions.view') }}</a>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import Navigation from './Nav/Navigation.vue'
import getStoreRole from '@mixins/store_roles'

export default {
    layout: Navigation,

    name: 'EditRoles',

    mixins: [getStoreRole],

    props: {
        storeUuid: String,
        roles: Array,
    },

    methods: {
        labelStyle(color) {
            if (color === null) {
                return
            }

            return `background-color: #${color}; color: white;`
        },
    },
}
</script>
